<div fxLayout="column" class="layout-padd rad-bord bordered back">

  <!-- Rub title -->
  <div class="mat-headline title-rub-prod dark-ico" fxLayoutAlign="start center" fxLayoutGap="10px"
    id="searchproductrub">

    <div class="rub-title ">{{"mySearch"|translate}}
    </div>

    <mat-icon>search</mat-icon>

  </div>

  <div *ngIf="findedProducts.length >0" fxFlex >

    <!-- Grid type -->
    <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap.xs="10px"
      *ngIf="pointOfsale && !pointOfsale.webshop_display_mode || media.isActive('xs')">

      <!-- Card product -->
      <div *ngFor="let prod of findedProducts; let first = first;" class="clicked card-padd" ngClass.xs="card-padd-xs"
        style="position: relative;" fxFlex="50" fxFlex.xs=100 (click)="openProdDial(prod)" angulartics2On="click"
        angularticsAction="openProductDialog" angularticsCategory="products">

        <!-- Out of stock badge -->
        <div class="out-of-stock-badge-grid text-align" fxLayoutAlign="center center"
          *ngIf="prod.stock && prod.stock.count === 0">
          <span class="boldest mat-caption">{{"unavailable"|translate}}</span>
        </div>

        <!-- Price period Badge -->
        <div *ngIf="prod.prices[0].id_price_period > 0" class="layout-padd-1 secondary clicked promo-badge-grid"
          (click)="myDials.openPromoShedulesDial(prod.prices[0].id_price_period); $event.stopPropagation()" angulartics2On="click"
          angularticsAction="openPromoShedulesDial" angularticsCategory="product">
          <span class="mat-caption boldest">{{productService.getPricePeriodName(prod.prices[0].id_price_period) | capitalize}}</span>
        </div>

        <div fxLayout="row" class="rad-bord full-screen"
          [class.out-of-stock-prod]="prod.stock && prod.stock.count === 0"
          style="padding: 10px; background: white; border: 1px solid #ddd;" fxFlex>

          <div fxLayout="column" fxFlex>

            <div style="padding-bottom: 5px;">
              <!-- <span class="list-title">{{prod.name}}</span> -->
              <span class="list-title">{{prod.display_lang.name}}</span>
            </div>

            <div  class="truncate-text-2" *ngIf="prod.description">
              <p class="list-desc desc-color">{{prod.display_lang.description | removeHtmlFromString }}</p>
            </div>

            <div fxFlex></div>

            <span style="padding-top: 5px;" class="list-price"
              *ngIf="prod.prices[0].price && prod.prices[0].price > 0">{{prod.prices[0].price|discountVipFilter:merchantClient$:prod
              | priceFilter}}</span>

          </div>

          <img *ngIf="prod.image.length > 0" src="{{prod.image[1]}}" class="prod-img rad-bord" ngClass.xs="prod-img-xs">

        </div>

      </div>

    </div>

    <!-- List Type -->
    <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap.xs="10px"
      *ngIf="pointOfsale && pointOfsale.webshop_display_mode && !media.isActive('xs')">

      <!-- Card product -->
      <div *ngFor="let prod of findedProducts; let first = first;" class="clicked card-padd" ngClass.xs="card-padd-xs"
        style="height: 300px; position: relative;" fxFlex="33" fxFlex.md=50 fxFlex.xl=25 fxFlex.xs=100
        (click)="openProdDial(prod)" angulartics2On="click" angularticsAction="openProductDialog"
        angularticsCategory="products">

        <div fxLayout="column" fxLayoutGap="5px" class="rad-bord whited"
          style="border: 1px solid #ddd;  position: relative;" fxFlex>

          <!-- Out of stock badge -->
          <div class="out-of-stock-badge-card full-w text-align" fxLayoutAlign="center center"
            *ngIf="prod.stock && prod.stock.count === 0">
            <span class="mat-caption boldest">{{"unavailable"|translate}}</span>
          </div>

          <!-- Price period Badge -->
          <div *ngIf="prod.prices[0].id_price_period > 0" class="layout-padd-1 rad-bord secondary clicked promo-badge-card"
            (click)="myDials.openPromoShedulesDial(prod.prices[0].id_price_period); $event.stopPropagation()" angulartics2On="click"
            angularticsAction="openPromoShedulesDial" angularticsCategory="product">
            <span class="mat-caption boldest">{{productService.getPricePeriodName(prod.prices[0].id_price_period) | capitalize}}</span>
          </div>

          <div class="pos-img-cont rad-bord" [class.out-of-stock-prod]="prod.stock && prod.stock.count === 0"
            fxFlex="80"
            [ngStyle]="{'background-image': 'url(' + ( prod.image.length > 0 ? prod.image[2] : default_prod) + ')'}">
          </div>

          <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center center" style="padding:10px;" fxFlex>

            <div fxLayoutAlign="center center" class="full-w">
              <!-- <span class="list-title">{{prod.name}}</span> -->
              <span class="list-title">{{prod.display_lang.name}}</span>
            </div>

            <span class="list-price" *ngIf="prod.prices[0].price && prod.prices[0].price > 0">{{prod.prices[0].price |
              priceFilter}}</span>

            <div fxFlex *ngIf="!prod.prices[0].price || prod.prices[0].price &&  prod.prices[0].price === 0">
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

  <div *ngIf="findedProducts.length <1" fxLayoutAlign="center center" class="layout-padd text-center">
    <span class="mat-sub-heading-1">{{"product.noProduct"|translate}}</span>
  </div>

</div>
